<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title"><strong>Account Details</strong></h3>
  <div class="header-actions">
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="panel panel-default">
  <div class="panel-body">
    
    <!-- Loading Indicator -->
    @if (isLoading) {
<div class="loading-container">
      <i class="fa fa-spinner fa-spin fa-2x"></i>
    </div>
}

    <!-- Data Table -->
    @if (!isLoading) {
<div>
      @if (hasValidData) {
<table class="table table-striped blue">

        <!-- Table Header -->
        <thead>
          <tr>
            <!-- Schedule M Header -->
            @if (isScheduleMMode) {
<th>Schedule M</th>
}
            
            <!-- Account Headers -->
            @if (isAccountMode) {
<th>System Account</th>
}
            @if (isAccountMode && showLocalAccountColumn) {
<th>Local Account</th>
}
          </tr>
        </thead>

        <!-- Table Body -->
        <tbody>
          <!-- Schedule M Rows -->
          @for (sche of scheduleMInformation; track $index) {
<tr [hidden]="!isScheduleMMode">
            <td>{{ sche.SCHDM_DESC }}</td>
          </tr>
}

          <!-- Account Rows -->
          @for (acct of accountInformation; track $index) {
<tr [hidden]="!isAccountMode">
            <td>{{ formatSysAcctDesc(acct.P_SYS_ACCT_DESC) }}</td>
            @if (showLocalAccountColumn) {
<td>{{ acct.P_LOCAL_ACCT_DESC }}</td>
}
          </tr>
}

          <!-- Empty State -->
          @if ((isAccountMode && accountInformation.length === 0) || (isScheduleMMode && scheduleMInformation.length === 0)) {
<tr>
            <td [attr.colspan]="isAccountMode && showLocalAccountColumn ? 2 : 1" class="text-center">
              No data available
            </td>
          </tr>
}
        </tbody>
      </table>
}

      <!-- No valid data available -->
      @if (!hasValidData) {
<div class="text-center text-muted">
        No data to display
      </div>
}
    </div>
}

  </div>
</div>
